export function headerEvents() {

    $('#nav-button').click(function (e) {

        e.preventDefault();

        if ($('body').hasClass('active-header_js')) {
            $('main').css('z-index', '5');
            $('body').removeClass('active-header_js');
            $('nav.navigation').animate({ 'right': '-100vw' }, 300);

			if ($(window).width() < 1024) {
				var scroll = $(window).scrollTop();
				scroll < 200 ? $('.logo-scroll').fadeIn(300) : [];
			} else {
				$('.logo-scroll').fadeIn(300);
				$('.logo-top').fadeIn(300);
			}

        } else {
            $('main').css('z-index', '');
            $('body').addClass('active-header_js');
            $('nav.navigation').show();
            $('nav.navigation').animate({ 'right': '0' }, 300);
            $('.logo-scroll').fadeOut(300);
            $('.logo-top').fadeOut(300);
        }

    });

    $(".btn-hover").on("click", function () {
        $(this).addClass('arrow-btn');
    });

    $("nav.navigation .close-btn").on("click", function (e) {
        e.preventDefault();
        $("nav.navigation").removeClass("open");
    });


	var headerScroll = function () {
		$(window).scrollTop() > 200
			? $('header.header').addClass('scroll')
			: $('header.header').removeClass('scroll');
	};

	function enableScrolling() {
		if (($('body.Home')[0]) && (!$('body').hasClass('scroll-page'))) {
			$('body').addClass('scroll-page');

			if (!$('html, body').hasClass('lock')) {
				$('html, body').addClass('lock');
			}
			setTimeout(function () {
				$('html, body').animate({ scrollTop: 0 }, 0);
				$('.hero-banner').addClass('d-none');
				$('html, body').removeClass('lock hide-scrollbar');
			}, 1000);
		}
	}

	function setHomeScrollingLogic() {
		if ($('body.Home').length > 0) {
			($(window).width() < 769)
				? $('html, body').addClass('lock')
				: $('html, body').addClass('hide-scrollbar');
		}	
	}

	function processFileFormats() {
		$('.file-format').each(function () {
			var fileFormat = $(this).find('.format-id').text().split('.').pop();

			fileFormat == 'jpg' || fileFormat == 'jpeg' || fileFormat == 'png' || fileFormat == 'gif'
				? $(this).addClass('image-format')
				: $(this).addClass('video-format')
		});
	}

	$(window).scroll(function () {
		headerScroll();
		enableScrolling();
	});

	/* Required to cover android phones - (window).scroll doesn't always fire */
	$('body.Home').on('touchmove', function () {
		enableScrolling();
	});

	$(window).on("load", function () {
		headerScroll();
		setHomeScrollingLogic();
		processFileFormats(); 
	});
}

